import React from 'react';

const ContactUs = () => {
  return (
    <footer className="w-full text-white">
      <div className="px-5 sm:px-8 lg:px-10 py-6">
        <div className="max-w-[1240px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            {/* Brand */}
            <div className="text-center sm:text-left">
              <p className="text-2xl sm:text-3xl font-extrabold tracking-tight leading-none">
                EduBahamas
              </p>
              <p className="mt-1 text-sm sm:text-base text-white/90 font-semibold">
                Study Better. Study Smarter.
              </p>
            </div>

            {/* Contact */}
            <div className="flex justify-center sm:justify-end">
              <a
                href="mailto:info.edubahamas@gmail.com?subject=EduBahamas%20Support"
                className="group inline-flex rounded-2xl bg-white/10 px-5 py-3 border border-white/10
                  transition-all duration-200 ease-out
                  hover:bg-white/15 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-black/20"
              >
                <div className="flex flex-col leading-tight">
                  {/* top line: icon inline with label */}
                  <div className="flex items-center gap-2">
                    <svg
                      className="h-5 w-5 opacity-90 shrink-0"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M4 7.5A2.5 2.5 0 0 1 6.5 5h11A2.5 2.5 0 0 1 20 7.5v9A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-9Z"
                        stroke="currentColor"
                        strokeWidth="1.6"
                      />
                      <path
                        d="M6.5 7.5 12 12l5.5-4.5"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <span className="text-sm sm:text-base font-semibold">
                      Email EduBahamas
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-5 border-t border-white/10" />

          <div className="mt-3 text-xs sm:text-sm text-white/60 text-center">
            © {new Date().getFullYear()} EduBahamas. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ContactUs;
